interface CircleLineProps {
  option: "init" | "middle" | "end";
  showLine?: boolean;
}

export default function CircleLine({
  option = "init",
  showLine = true,
}: CircleLineProps) {
  const getLineElement = () => {
    if (!showLine) return null;

    switch (option) {
      case "init":
        return <div className="w-px border-l border-neutral-quiet flex-grow" />;
      case "middle":
        return <div className="w-px border-l border-neutral-quiet flex-grow" />;
      case "end":
        return null; // No line after the last item
      default:
        return <div className="w-px border-l border-neutral-quiet flex-grow" />;
    }
  };

  return (
    <div className="flex flex-col items-center flex-shrink-0">
      {/* Circle/Dot */}
      <div className="relative w-2.5 h-2.5 z-10 mt-2">
        <div className="absolute inset-0 rounded-full bg-white" />
        <div className="absolute inset-0 rounded-full bg-neutral-object-accent-loud" />
      </div>
      {/* Connecting line */}
      {getLineElement()}
    </div>
  );
}
